<template>
  <div class="home antialiased">
    <div
      class="relative overflow-hidden bg-repeat h-screen bg-cover bg-center z-40"
    >
      <div class="inset-x-0 top-0 h-screen w-full z-5">
        <main class="flex flex-wrap h-full w-full justify-center items-center">
          <div class="text-center">
            <video
              autoplay
              muted
              loop
              playsinline
              defaultMuted
              webkit-playsinline
              preload="auto"
              poster="https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fnovid_800x800.png?alt=media&token=c563f0f2-810b-409f-b039-33b1d2b3c7f2"
              class="w-full md:max-w-full -z-10 object-cover heroVideo"
              src="https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/TSBC_NO_FADE720.mp4?alt=media&token=b7aa166d-f4e3-4249-9042-7f53c6325fcb"
            >
              <source
                src="https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/TSBC_NO_FADE720.mp4?alt=media&token=b7aa166d-f4e3-4249-9042-7f53c6325fcb"
                type="video/mp4"
              />
            </video>
          </div>
        </main>
      </div>
    </div>
    <!--HERO-->

    <!--ENDHERO-->
    <div class="h-2 w-full secondaryBG"></div>
    <!--SUBHEADER-->
    <div class="relative bg-black bg-center bg-cover subHeader z-10">
      <!-- class="fixed w-full m-auto top-0 animated z-30 sm:bg-transparent" -->

      <div
        v-observe-visibility="visibilityChanged"
        class="w-full m-auto animated relative sm:bg-transparent z-30"
        :class="[navToggled ? 'bg-black' : 'bg-transparent']"
      >
        <div class="h-2 w-full secondaryBG"></div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex justify-between h-16">
            <div class="flex">
              <div class="flex-shrink-0 flex items-center">
                <img
                  class="block lg:hidden h-8 w-auto"
                  src="https://timessquareboxing.com/images/logo.png"
                  alt="TSBC"
                />
                <img
                  class="hidden lg:block h-8 w-auto"
                  src="https://timessquareboxing.com/images/logo.png"
                  alt="TSBC"
                />
              </div>
            </div>
            <div class="hidden sm:ml-6 sm:flex sm:items-center">
              <div class="hidden sm:ml-6 sm:flex ultraFont text-secondary">
                <button
                  type="button"
                  v-scroll-to="'#fighters'"
                  class="inline-flex items-center px-1 pt-1 text-md leading-5 focus:outline-none transition duration-150 ease-in-out"
                >
                  FIGHTERS
                </button>
                <button
                  type="button"
                  v-scroll-to="'#about'"
                  class="ml-8 inline-flex items-center px-1 pt-1 text-md leading-5 focus:outline-none transition duration-150 ease-in-out"
                >
                  ABOUT
                </button>
                <button
                  type="button"
                  v-scroll-to="'#footer'"
                  class="ml-8 inline-flex items-center px-1 pt-1 text-md leading-5 focus:outline-none transition duration-150 ease-in-out"
                >
                  CONTACT
                </button>
              </div>
            </div>
            <div class="-mr-2 flex items-center sm:hidden">
              <!-- Mobile menu button -->
              <button
                class="inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-black hover:text-TSBCSECONDARY focus:outline-none focus:bg-black focus:transition duration-150 ease-in-out"
                aria-label="Main menu"
                aria-expanded="false"
                @click="navToggled = !navToggled"
              >
                <!-- Icon when menu is closed. -->
                <!-- Menu open: "hidden", Menu closed: "block" -->
                <svg
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  :class="[navToggled ? 'hidden' : 'block']"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>

                <svg
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  :class="[navToggled ? 'block' : 'hidden']"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div
          class="sm:hidden transition ease-in-out duration-150"
          :class="[navToggled ? 'block' : 'hidden ']"
        >
          <div class="pt-2 pb-3">
            <button
              type="button"
              v-scroll-to="'#fighters'"
              @click="navToggled = !navToggled"
              class="mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent bookFont text-TSBCSECONDARY hover:text-TSBCPRIMARY hover:border-TSBCPRIMARY focus:outline-none focus:text-TSBCPRIMARY focus:bg-gray-50 focus:border-TSBCSECONDARY transition duration-150 ease-in-out"
            >
              FIGHTERS
            </button>
            <button
              type="button"
              v-scroll-to="'#about'"
              @click="navToggled = !navToggled"
              class="mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent bookFont text-TSBCSECONDARY hover:text-TSBCPRIMARY hover:border-TSBCPRIMARY focus:outline-none focus:text-TSBCPRIMARY focus:bg-gray-50 focus:border-TSBCSECONDARY transition duration-150 ease-in-out"
            >
              ABOUT
            </button>
            <button
              type="button"
              v-scroll-to="'#footer'"
              @click="navToggled = !navToggled"
              class="mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent bookFont text-TSBCSECONDARY hover:text-TSBCPRIMARY hover:border-TSBCPRIMARY focus:outline-none focus:text-TSBCPRIMARY focus:bg-gray-50 focus:border-TSBCSECONDARY transition duration-150 ease-in-out"
            >
              CONTACT
            </button>
          </div>
        </div>
      </div>
      <nav
        v-show="!isVisible"
        class="w-full m-auto animated z-30 sm:bg-transparent fixed top-0"
        :class="[navToggled ? 'bg-black' : 'bg-transparent']"
      >
        <div class="h-2 w-full secondaryBG"></div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex justify-between h-16">
            <div class="flex">
              <div class="flex-shrink-0 flex items-center">
                <img
                  class="block lg:hidden h-8 w-auto"
                  src="https://timessquareboxing.com/images/logo.png"
                  alt="TSBC"
                />
                <img
                  class="hidden lg:block h-8 w-auto"
                  src="https://timessquareboxing.com/images/logo.png"
                  alt="TSBC"
                />
              </div>
            </div>
            <div class="hidden sm:ml-6 sm:flex sm:items-center">
              <div class="hidden sm:ml-6 sm:flex ultraFont text-secondary">
                <button
                  type="button"
                  v-scroll-to="'#fighters'"
                  class="inline-flex items-center px-1 pt-1 text-md leading-5 focus:outline-none transition duration-150 ease-in-out"
                >
                  FIGHTERS
                </button>
                <button
                  type="button"
                  v-scroll-to="'#about'"
                  class="ml-8 inline-flex items-center px-1 pt-1 text-md leading-5 focus:outline-none transition duration-150 ease-in-out"
                >
                  ABOUT
                </button>
                <button
                  type="button"
                  v-scroll-to="'#footer'"
                  class="ml-8 inline-flex items-center px-1 pt-1 text-md leading-5 focus:outline-none transition duration-150 ease-in-out"
                >
                  CONTACT
                </button>
              </div>
            </div>
            <div class="-mr-2 flex items-center sm:hidden">
              <!-- Mobile menu button -->
              <button
                class="inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-black hover:text-TSBCSECONDARY focus:outline-none focus:bg-black focus:transition duration-150 ease-in-out"
                aria-label="Main menu"
                aria-expanded="false"
                @click="navToggled = !navToggled"
              >
                <!-- Icon when menu is closed. -->
                <!-- Menu open: "hidden", Menu closed: "block" -->
                <svg
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  :class="[navToggled ? 'hidden' : 'block']"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
                <!-- Icon when menu is open. -->
                <!-- Menu open: "block", Menu closed: "hidden" -->
                <svg
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  :class="[navToggled ? 'block' : 'hidden']"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!--
    Mobile menu, toggle classes based on menu state.

    Menu open: "block", Menu closed: "hidden"
      -->
        <div
          class="sm:hidden transition ease-in-out duration-150"
          :class="[navToggled ? 'block' : 'hidden ']"
        >
          <div class="pt-2 pb-3">
            <button
              type="button"
              v-scroll-to="'#fighters'"
              @click="navToggled = !navToggled"
              class="mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent bookFont text-TSBCSECONDARY hover:text-TSBCPRIMARY hover:border-TSBCPRIMARY focus:outline-none focus:text-TSBCPRIMARY focus:bg-gray-50 focus:border-TSBCSECONDARY transition duration-150 ease-in-out"
            >
              FIGHTERS
            </button>
            <button
              type="button"
              v-scroll-to="'#about'"
              @click="navToggled = !navToggled"
              class="mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent bookFont text-TSBCSECONDARY hover:text-TSBCPRIMARY hover:border-TSBCPRIMARY focus:outline-none focus:text-TSBCPRIMARY focus:bg-gray-50 focus:border-TSBCSECONDARY transition duration-150 ease-in-out"
            >
              ABOUT
            </button>
            <button
              type="button"
              v-scroll-to="'#footer'"
              @click="navToggled = !navToggled"
              class="mt-1 block pl-3 pr-4 py-2 border-l-4 border-transparent bookFont text-TSBCSECONDARY hover:text-TSBCPRIMARY hover:border-TSBCPRIMARY focus:outline-none focus:text-TSBCPRIMARY focus:bg-gray-50 focus:border-TSBCSECONDARY transition duration-150 ease-in-out"
            >
              CONTACT
            </button>
          </div>
        </div>
      </nav>
      <div class="relative px-4 sm:px-6 lg:px-8 z-30">
        <div
          class="text-xs md:text-lg max-w-prose mx-auto text-white pt-2 md:pt-12"
        >
          <p class="text-center uppercase bookFont">TIMELESS PRINCIPLES</p>
          <p class="text-center uppercase bookFont">
            FOR FUTURE BOXING CHAMPIONS
          </p>
          <div class="mt-2 text-center leading-8 font-extrabold">
            <img
              :src="`${publicPath}assets/images/tsstar.png`"
              class="h-auto md:h-64 w-full object-contain"
            />
          </div>
          <p
            class="text-10vw md:text-16xw text-center text-secondary ultraFont font-black"
            data-aos="fade-in"
            data-aos-duration="1000"
          >
            THE FIGHTERS
          </p>
        </div>
      </div>
    </div>

    <div class="relative overflow-hidden fighterWrapper" id="fighters">
      <div
        class="absolute inset-x-0 top-0 h-8 -mt-3 md:h-16 flex justify-center"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="w-24"
          viewBox="0 0 134.92 82.13"
          style="overflow: visible; enable-background: new 0 0 134.92 82.13"
        >
          <polygon class="st0" points="0,10.33 64.67,82.13 134.92,0 " />
        </svg>
      </div>
      <div
        class="max-w-screen-xl mx-auto px-2 text-center sm:px-6 lg:px-8 py-4 md:py-16"
      >
        <div class="space-y-12">
          <div
            class="space-y-5 sm:mx-auto sm:max-w-xl sm:space-y-4 lg:max-w-5xl"
          >
            <h2 class="text-lg md:text-2xl text-white bookFont pt-4">
              CURRENT ATHLETE ROSTER
            </h2>
          </div>
          <ul
            class="mx-auto grid grid-cols-2 gap-8 md:gap-16 space-y-0 md:grid-cols-3 lg:max-w-5xl"
          >
            <Boxer
              v-for="(contender, index) in boxers"
              :key="index"
              v-bind="contender"
            />
          </ul>
        </div>
      </div>
    </div>

    <div id="about" class="relative bg-black flex flex-wrap sm:flex-nowrap">
      <div
        class="mx-auto flex order-2 flex-1 md:justify-center md:w-1/3 items-center"
      >
        <div class="relative lg:max-w-2xl lg:w-full flex-1 pt-2">
          <main
            class="justify-center mt-10 mx-auto max-w-screen-xl md:mt-16 lg:mt-20 lg:px-8 xl:mt-28 flex flex-wrap items-center content-center px-4"
          >
            <div class="space-y-4">
              <div
                class="w-full flex justify-center sm:justify-center lg:justify-start"
              >
                <div class="block">
                  <div
                    data-aos="fade-in"
                    data-aos-duration="1000"
                    class="text-18vw text-6xl md:text-7xl xl:text-8xl ultraFont oldSchoolRoots aos-init aos-animate"
                  >
                    OLD SCHOOL ROOTS
                  </div>
                </div>
              </div>
              <div
                class="mt-3 sm:mt-5 sm:max-w-xl sm:mx-auto md:mt-5 lg:mx-0 space-y-4"
              >
                <p
                  class="text-white bookFont leading-relaxed text-center md:text-left"
                >
                  The name “Times Square Boxing” is an homage to the
                  world-famous Times Square Boxing Gym, of the 1970’s, 80’s and
                  early 90’s, owned and operated by the legendary, Jimmy Glenn,
                  and which hosted such greats as Roberto Duran, Sugar Ray
                  Leonard, Julio Cesar Chavez and Muhammad Ali. It is also the
                  place where the founders of Times Square Boxing, Joe Winters
                  and Adam Glenn, began their love affair with the sport.
                </p>
                <p
                  class="text-white bookFont leading-relaxed text-center md:text-left"
                >
                  The principles that guide Times Square Boxing Co.—honesty,
                  integrity, hard work and care—were instilled through the
                  lessons learned from the great gentlemen of boxing that
                  preceded us. At Times Square Boxing, we admire and respect the
                  beauty and art of the sweet science that is boxing, while
                  recognizing that the business of boxing is ever-changing. We
                  strive to protect and guide our fighters inside and outside of
                  the ring, working tirelessly to advocate for them and provide
                  every advantage and opportunity to further their careers,
                  build their brands and to be successful.
                </p>
              </div>
            </div>
          </main>
        </div>
      </div>
      <div class="w-full sm:w-full md:w-1/2 lg:w-3/5">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2F22_800x800.png?alt=media&token=f567948c-0f54-4faa-abb9-c820640ac6c7"
          alt="tsbc"
          class="w-full h-full"
        />
      </div>
    </div>

    <!-- end new old school roots-->

    <div class="relative md:pt-8 md:py-16 overflow-hidden bg-black">
      <div class="relative sm:px-6 lg:px-8 text-white w-full">
        <div
          class="text-16xw max-w-prose mx-auto mb-6 text-center md:text-66xl ultraFont"
        >
          <p data-aos="fade-in" data-aos-duration="1000">THREE</p>
          <p class="leading-4" data-aos="fade-in" data-aos-duration="1000">
            GENERATIONS
          </p>
          <p data-aos="fade-in" data-aos-duration="1000">OF BOXING</p>
        </div>
      </div>
    </div>

    <Partner
      v-for="(partner, index) in partners"
      :key="index"
      v-bind="partner"
    />

    <div class="h-2 w-full secondaryBG"></div>

    <div class="bg-black" id="footer">
      <div
        class="hidden w-full mx-auto py-8 px-4 md:flex md:items-center justify-between"
      >
        <div
          class="order-1 md:order-3 flex flex-wrap justify-center align-center"
        >
          <img
            src="https://timessquareboxing.com/images/footerlogo.png"
            class="h-auto w-64 object-contain"
          />

          <p
            class="text-white bookFont w-full text-center pt-6"
            style="font-size: xx-small"
          >
            © 2020 Times Square Boxing Co. All Rights Reserved.
          </p>
        </div>
        <div class="order-1 md:order-2">
          <a
            href="https://www.instagram.com/timessquareboxing/"
            target="_blank"
          >
            <img
              src="https://timessquareboxing.com/images/instafoot.png"
              class="h-auto w-8 object-contain"
            />
          </a>
        </div>
        <div class="order-5 md:order-5">
          <p class="text-center text-secondary ultraFont">INQUIRIES</p>
          <p class="text-center text-white bookFont">ADAM GLENN</p>
          <a
            href="mailto:aglenn@timessquareboxing.com"
            class="text-center text-white bookFont"
            >AGLENN@TIMESSQUAREBOXING.COM</a
          >

          <p class="text-center text-white bookFont"></p>
        </div>
        <div class="order-4 md:order-4">
          <a href="mailto:aglenn@timessquareboxing.com">
            <img
              src="https://timessquareboxing.com/images/mailfoot.png"
              class="h-auto w-8 object-contain object-center"
            />
          </a>
        </div>
        <div class="order-1 md:order-1">
          <p class="text-center text-secondary ultraFont">LOCATION</p>
          <p class="text-center text-white bookFont">140 W 44th ST</p>
          <p class="text-center text-white bookFont">NEW YORK, NY 10036</p>
        </div>
      </div>
      <div class="md:hidden w-full mx-auto py-6 px-2">
        <div class="w-full order-1 md:order-3">
          <img
            src="https://timessquareboxing.com/images/footerlogo.png"
            class="h-24 w-full object-contain"
          />
        </div>
        <div
          class="w-full mt-2 order-2 text-white blackFont text-center text-xs"
        >
          140 W 44th ST NEW YORK, NY 10036
        </div>
        <div class="flex flex-wrap justify-between">
          <div class="col-start-2 col-span-1">
            <a
              href="https://www.instagram.com/timessquareboxing/"
              target="_blank"
            >
              <img
                src="https://timessquareboxing.com/images/instafoot.png"
                class="h-6 object-contain"
              />
            </a>
          </div>
          <div class="text-center col-start-4 col-end-10">
            <p class="text-secondary ultraFont text-sm">INQUIRIES</p>
            <p class="text-white blackFont text-xs">ADAM GLENN</p>
            <a
              href="mailto:aglenn@timessquareboxing.com"
              class="text-xs text-white bookFont"
              >AGLENN@TIMESSQUAREBOXING.COM</a
            >

            <p
              class="text-xs text-white bookFont pt-2"
              style="font-size: xx-small"
            >
              © 2020 Times Square Boxing Co. All Rights Reserved.
            </p>
          </div>
          <div class="col-start-11 col-span-1">
            <a href="mailto:aglenn@timessquareboxing.com">
              <img
                src="https://timessquareboxing.com/images/mailfoot.png"
                class="h-6 object-contain object-center"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--/footer-->
  </div>
</template>

<script>
import Boxer from "@/components/common/Boxer";
import Partner from "@/components/common/Partner";
export default {
  name: "Home",
  components: {
    Boxer,
    Partner,
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },

  data() {
    return {
      navToggled: false,
      mxLines: 4,
      publicPath: process.env.BASE_URL,
      partners: [
        {
          isLeft: false,
          name: "JIMMY GLENN",
          title: "CHAIRMAN EMERITUS & MENTOR",
          image: "../assets/images/p1.png",
          imageLg:
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fjimmy1_800x800.jpg?alt=media&token=ff13abf0-cb02-4a80-be61-2ca0bc6aba8e",
          descOne:
            "Jimmy Glenn, who passed in May 2020, was the unofficial godfather of New York boxing. Jimmy was a Hall of Fame manager, trainer and cutman; however, more importantly, Jimmy was a mentor who gave selflessly through boxing to a multitude of young men who benefitted from his time, attention and love.",
          descTwo:
            "Universally recognized as one of the “good guys” in boxing, Jimmy built a reputation for honesty, integrity and deep caring for all the fighters that he worked with, and he was one of the few people in boxing that had no enemies. Times Square Boxing Co. carries on Jimmy’s legacy of helping fighters become great boxers in the ring and great human beings outside of it. We channel what he stood for in all we do.",

          photos: [
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fjimmy1_800x800.jpg?alt=media&token=ff13abf0-cb02-4a80-be61-2ca0bc6aba8e",
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fjimmy2_800x800.jpg?alt=media&token=1c3746d7-6365-4934-9963-5b30ccca243a",
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fjimmy3_800x800.jpg?alt=media&token=e4700a07-a21a-49b1-9ac3-837470b12d57",
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fjimmy4_800x800.jpg?alt=media&token=e5059ad1-2245-4a33-bb6e-752c60ecc01f",
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fjimmy5_800x800.jpg?alt=media&token=348b54aa-3395-4384-a17e-83e3d5e900be",
          ],
        },
        {
          isLeft: true,
          name: "Joe Winters",
          title: "Chairman & Co-Founder",
          image: "../assets/images/p2.png",
          imageLg: "../assets/images/p2.png",
          descOne: `A former professional heavyweight boxer, Joe Winters was trained by Jimmy Glenn and mentored by his father, Jimmy Winters, a boxing promoter and successful New York businessman.`,
          descTwo: `After retiring from boxing, Mr. Winters became an industry icon in the waste management and recycling industry, building and acquiring more than 100 companies. With Times Square Boxing Co., Joe is returning to his first love and life-long passion, boxing, with the goal of creating champions while mentoring and taking care of his fighters the right way.`,
          photos: [
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fjoe1_800x800.jpg?alt=media&token=6b4a953d-e36e-4705-8645-f6181846603e",
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fjoe2_800x800.jpg?alt=media&token=f1ae8185-e9ba-429f-b48e-c153b586dfc5",
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fjoe3_800x800.jpg?alt=media&token=a1fe87ec-0c59-45d9-b4cd-f1e895e4da81",
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fjoe4_800x800.jpg?alt=media&token=ce8e4518-36ec-4d9f-b5bf-c677c9723900",
          ],
        },
        {
          isLeft: false,
          name: "Adam Glenn",
          title: "CEO & Co-Founder",
          image: "../assets/images/p3.png",
          imageLg: "../assets/images/p3.png",
          descOne: `A Harvard-educated former lawyer and the son of New York City boxing legend Jimmy Glenn, Adam Glenn grew up in the gym and on the road, learning about the sport and the business of boxing from his father. After a promising law career, Mr. Glenn left and returned to boxing.`,
          descTwo: `Adam brings a deep understanding of the sport, along with a dynamic fresh perspective on the boxing business and an unrelenting dedication to each of his fighters. Adam Glenn is also the owner of the world-famous boxing bar Jimmy’s Corner, located in Times Square.`,
          photos: [
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fadam1_800x800.jpg?alt=media&token=ee22ecde-5332-4b52-a63b-895fe4e398a3",
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fadam2_800x800.jpg?alt=media&token=b1766546-d98f-4e18-86b9-eac3440d00b7",
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fadam3_800x800.jpg?alt=media&token=54c0e3ff-5d60-46bd-aeb2-1aa5c29748c1",
            "https://firebasestorage.googleapis.com/v0/b/xyzstream-1.appspot.com/o/thumbs%2Fadam4_800x800.jpg?alt=media&token=9d1cc916-7ff5-49e3-898d-9208ede48f29",
          ],
        },
      ],
      boxers: [
        {
          fullName: "DUSHANE CROOKS",
          first: "DUSHANE",
          last: "CROOKS",
          record: "13 - 2",
          weight: "MIDDLEWEIGHT",
          hometown: "BROOKLYN, NY",
          description: `Displaying a unique combination of speed, power and tenacity, Dushane Crooks is a force to be reckoned with. As an amateur, Mr. Crooks was called “Lil Tyson” because he mimicked the style of his childhood idol, Iron Mike Tyson. Over the years, Dushane developed a well-rounded, entertaining style that combines a ferocious body attack, relentless pressure and beautiful boxing. Dushane is an old school fighter, who has all the tools to become a future champion.
`,
          insta: "du_718",
          image: "../assets/images/a.png",
          boxerRec: "https://boxrec.com/en/proboxer/572098",
        },
        {
          fullName: "Dominique “Dimes” Crowder",
          first: "Dominique “Dimes”",
          last: "Crowder",
          record: "6-0",
          weight: "Super Bantamweight",
          hometown: "Baltimore, MD",
          description: `With a spectacular amateur career, Dominique “Dimes” Crowder made a name for himself as one of the top amateurs in the US. Compiling an 82-7 record as an amateur, Dimes was a 2-time NY Golden Glove Champion, a New York Ringmaster Champion and the number two-ranked Bantamweight in the USA. A tall and rangy fighter, with surprising power in both hands, and a high level of boxing ability, Dominique is a future world champion in the making.
`,
          insta: "lor_dimes",
          image: "../assets/images/b.png",
          boxerRec: "https://boxrec.com/en/proboxer/859608",
        },
        {
          fullName: "Steven Galeano",
          first: "Steven",
          last: "Galeano",
          record: "4-0",
          weight: "Super Lightweight",
          hometown: "New York, NY",
          description: `A young phenom, Steven Galeano won the New York Ringmaster Tournament, formerly the New York Golden Gloves, at age 19, only one of his many amateur accomplishments. A true student of boxing, Steven has a style that is much more mature than his years, complete with a strong jab, solid body punching and great ring generalship. Steven is a down-to-earth young man, with an incredible work ethic, who is building a solid foundation for his future as a star in boxing.`,
          insta: "stevengaleano_",
          image: "../assets/images/c.png",
          boxerRec: "https://boxrec.com/en/proboxer/863444",
        },
        {
          fullName: "Jeremy “Zereaux” Hill",
          first: "Jeremy “Zereaux”",
          last: "Hill",
          record: "13-0",
          weight: "Lightweight",
          hometown: "New Orleans, LA",
          description: `An entertainer in and out of the ring, Jeremy “Zereaux” Hill puts the show in the show. Inside the ring, Jeremy is a vicious body puncher, with size, great reflexes and power in both hands. Outside of the ring, Zereaux is a showman, with boundless fun-loving energy, quick wit and an unmistakable New Orleans accent. Zereaux had a decorated amateur career, winning national tournaments and ranking 4th in the nation prior to turning pro. Zereaux’s boxing ability, coupled with his personality and genuine humbleness, have him primed to be a star in the sport.`,
          insta: "say_zereaux",
          image: "../assets/images/d.png",
          boxerRec: "https://boxrec.com/en/proboxer/834886",
        },
        {
          fullName: "Sean “Silky” Hemphill",
          first: "Sean “Silky”",
          last: "Hemphill",
          record: "8-0",
          weight: "Super Middleweight",
          hometown: "New Orleans, LA",
          description: `One of the most decorated amateurs in Louisiana history, Sean “Silky” Hemphill won numerous national tournaments, the Louisiana Golden Gloves and joined Team USA as the number two ranked Light Heavyweight in the US. Sean lives up to his nickname, Silky, displaying a slick and smooth ring style that leaves his opponents swinging at air as they are peppered with precise punches. Sean’s combination of athleticism, sharp punching and ring intelligence, coupled with his work ethic and humble demeanor, are a great recipe for a future champion.  `,
          insta: "silky504",
          image: "../assets/images/e.png",
          boxerRec: "https://boxrec.com/en/proboxer/860317",
        },
        {
          fullName: "Akil Knight",
          first: "Akil",
          last: "Knight",
          record: "11 - 3",
          weight: "Middleweight",
          hometown: "BROOKLYN, NY",
          description: `Exhibiting a rare combination of explosive power and defensive skill, Akil Knight is the definition of a boxer-puncher, who makes opponents miss and makes them pay dearly when hit. Akil had a decorated amateur career, competing across the country, winning both local and national tournaments. Akil has a dominating jab, that sets up his devastating power, and a methodical style that allows him to break down his opponent. Akil has the athletic talent, personal drive and ring savvy to be a champion.`,
          insta: "thatdud3_",
          image: "../assets/images/f.png",
          boxerRec: "https://boxrec.com/en/proboxer/615393",
        },
        {
          fullName: "“King” Nkosi Solomon",
          first: "“King” Nkosi",
          last: "Solomon",
          record: "1 - 1",
          weight: "Heavyweight",
          hometown: "BROOKLYN, NY",
          description: `Standing 6’7”, with long arms and elite athleticism, “King” Nkosi Solomon is a prodigious young
talent on the Heavyweight boxing scene. Nkosi had a highly decorated amateur career, as a 2-time NY
Golden Glove Champion, US National Champion, member of Team USA and the number one ranked
Super Heavyweight in the US. As professional, Nkosi is a rangy fighter, with a sharp jab and power in
both hands. Nkosi is rare talent, who, with his size, athleticism and intelligence, is poised to become a
future world champion.`,
          insta: "kingsolomonjourney",
          image: "../assets/images/gg.png",
          boxerRec: "https://boxrec.com/en/proboxer/846149",
        },
        {
          fullName: "“Mighty” Joe Ward",
          first: "“Mighty” Joe",
          last: "Ward",
          record: "0 - 1* (TKO by unrelated injury)",
          weight: "Light Heavyweight",
          hometown: "MOATE, IRELAND",
          description: `With a sensational amateur career, Joe Ward established himself as one of the very best amateur
prospects in the world. An Irish Amateur National Champion and former captain of the Irish National
Team, Joe performed impressively at every level in the amateur system, winning gold at the World
Junior Championships and the World Youth Championships, as a well winning the European Amateur Championships three times, bringing home silver twice at the World Amateur Championships and
representing Ireland in the 2016 Olympics in Rio. With his combination of speed, power and ring smarts,
Joe is poised for stardom in the professional ranks.`,
          insta: "mighy_joe_ward",
          image: "../assets/images/g.png",
          boxerRec: "https://boxrec.com/en/proboxer/851126",
        },
      ],
      view: {
        atTopOfPage: true,
      },
      isVisible: false,
    };
  },
  methods: {
    toggleDropdown(clamped) {
      if (clamped) {
        this.mxLines = 999;
      } else {
        this.mxLines = 4;
      }
    },
    handleScroll() {
      // when the user scrolls, check the pageYOffset
      if (window.pageYOffset > 0) {
        // user is scrolled
        if (this.view.atTopOfPage) this.view.atTopOfPage = false;
      } else {
        // user is at top of page
        if (!this.view.atTopOfPage) this.view.atTopOfPage = true;
      }
    },
    visibilityChanged(isVisible) {
      this.isVisible = isVisible;
    },
  },
};
</script>

<style lang="scss">
  .fade-in-section {
    opacity: 0;
    transform: translateY(20vh);
    visibility: hidden;
    transition: opacity 0.6s ease-out, transform 1.2s ease-out;
    will-change: opacity, visibility;
  }
  .fade-in-section.is-visible {
    opacity: 1;
    transform: none;
    visibility: visible;
  }
</style>